import styled from "styled-components";
import { SelectTypeWrapper } from "components/BiodiversitySelector/style";

/* Center the tab labels */
export const TabsWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-top: -37px;
`;

/* Keep the two tabs side-by-side */
export const TabsInner = styled.div`
  display: flex;
  gap: 40px;
  // padding-left:92px;
  position: relative;
`;

/* Individual tab */
export const TabItem = styled.div`
  position: relative;
  padding-bottom: 6px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
  color: ${(p) =>
    p.isActive ? "rgba(10, 161, 244, 1)" : "rgba(32, 32, 32, 0.6)"};

  &:hover {
    color: rgba(10, 161, 244, 1);
  }
  min-width: 230px;
  text-align: center;
`;

/* Small underline only below the label width */
export const TabUnderline = styled.div`
  height: 2px;
  width: 100%; /* underline only under the text */
  background: rgba(10, 161, 244, 1);
  border-radius: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
`;

/* Full-width divider BELOW tabs */
export const DividerLine = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(32, 32, 32, 0.15);
`;

export const ContentContainer = styled.div`
  margin-top: 24px;
  padding-bottom: 24px;
`;

export const TabsSummary = styled.div`
  display: flex;
  gap: 24px;
  border-bottom: 1px solid rgba(32, 32, 32, 0.15);

  button {
    background: none;
    border: none;
    padding: 12px 0;
    font-size: 14px;
    color: rgba(32, 32, 32, 0.6);
    cursor: pointer;
    position: relative;
    margin-top:10px
  }

  .active {
    color: #0AA1F4;
  }

  .active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: #0AA1F4;
  }
`

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
  flex-wrap: wrap;

  ${SelectTypeWrapper} {
    margin-left: auto;
  }
`

export const BulkActionsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
  flex-wrap: wrap;

  .bulk-select {
    min-width: 180px;
  }

  .left-controls {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .bulk-select {
    min-width: 180px;
  }
`

export const SpeciesHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px;
  font-size: 12px;
  color: rgba(32, 32, 32, 0.6);
  padding: 16px 0 8px;
  text-transform: uppercase;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
`

export const SpeciesList = styled.div`
  display: flex;
  flex-direction: column;
`

export const SpeciesRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 140px 120px;
  padding: 16px 0;
 border-bottom: ${props => (props.showBorderBottom === false ? 'none' : '1px solid rgba(32, 32, 32, 0.08)')};  padding-left: ${(props) => props.depth * 24}px;

  .left {
    display: flex;
    align-items: center;

  }
    &:not(:last-child) {
      border-color: rgb(255, 255, 255);
    }

  .right {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(32, 32, 32, 0.8);
    justify-content: flex-end;
  }

  .expand-cell {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .species-label {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: green;
    display: inline-block;
  }

  .child-indicator {

    font-size: 31px;

  }

  .status-dot {
    width: 9px; /* Adjust size as needed */
    height: 9px; /* Adjust size as needed */
    border-radius: 50%;
    background-color: #cfcfcf; /* Grey color for inactive */
  }

  .status-dot.grey {
    background-color: #cfcfcf; /* default grey */
  }

  .status-dot.green {
    background-color: #2ecc71; /* bright green */
  }

  .status-dot.blue {
    background-color: #0AA1F4; /* bright green */
  }
`

export const ExpandButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  font-size: 12px;
  color: rgba(32, 32, 32, 0.6);
  padding: 0px;
`

export const EcosystemRow = styled.div`

  display: grid;
  grid-template-columns: 1fr 130px 130px 200px;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid rgba(32, 32, 32, 0.08);
  padding-left: ${(props) => props.depth * 24}px;

  .left {
    display: flex;
    align-items: center;
  }

  .type-label {

    font-size: 14px;
    color: rgba(32, 32, 32, 0.8);
     text-align: right;
    flex: 1;
  }

  .expand-cell {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`

export const DetailHeaderRow = styled(EcosystemRow)`
  padding: 0 0px 16px;
  border-bottom: 1px solid rgba(32, 32, 32, 0.08);
  margin-bottom: 16px;
  background: transparent;

    .species-label {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: green;
    display: inline-block;
  }

  .status-dot {
    width: 9px; /* Adjust size as needed */
    height: 9px; /* Adjust size as needed */
    border-radius: 50%;
    background-color: #cfcfcf; /* Grey color for inactive */
  }

  .status-dot.grey {
    background-color: #cfcfcf; /* default grey */
  }

  .status-dot.green {
    background-color: #2ecc71; /* bright green */
  }

  .status-dot.blue {
    background-color: #0AA1F4; /* bright green */
  }
`

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
`

export const ExpandToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background:transparent;
  font-size: 13px;
  color: rgba(32, 32, 32, 0.8);
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
  }
`

export const DetailPanel = styled.div`
  background: transparent;
  border: none;
  border-radius: 0;
  margin: 8px 0 24px;
  padding: 0;
  padding-left: ${(props) => props.depth * 24 + 56}px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const DetailSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;


  &:last-of-type {
    margin-bottom: 0;
  }

`

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: rgba(32, 32, 32, 0.9);

  svg {
    width: 16px;
    height: 16px;
  }
`

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const TimingWrapper = styled.div`
  max-width: 700px;
`

export const DetailColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 32px;
  place-items: center;
`
export const TooltipBtnWrapper = styled.div`
  position: relative;
  display: inline-flex;

  &:hover span {
    visibility: visible;
    opacity: 1;
  }
`

export const TooltipBtnText = styled.span`
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease;

  position: absolute;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);

  background: rgba(32, 32, 32, 0.9);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: rgba(32, 32, 32, 0.9) transparent transparent transparent;
  }
`

export const ViewButton = styled.button`
  background-color: white;
  color: #797979;
  padding: 9px 10px;
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid #797979;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-left: auto;
  width: 170px;            /*  FIXED WIDTH */
  display: flex;
  justify-content: center;

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconSlot = styled.span`
  width: 20px;             /* 🔑 ICON SPACE RESERVED */
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextSlot = styled.span`
  white-space: nowrap;     /* 🔑 Prevent wrap */
`;